import { render } from "./page-hubungi-kami.vue?vue&type=template&id=78e24b38&scoped=true"
import script from "./page-hubungi-kami.vue?vue&type=script&lang=js"
export * from "./page-hubungi-kami.vue?vue&type=script&lang=js"

import "./page-hubungi-kami.vue?vue&type=style&index=0&id=78e24b38&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e24b38"]])

export default __exports__